/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-nested-ternary */
import { Authorisation } from "@iventis/domain-model/model/authorisation";
import { pointerAboveBelow } from "@iventis/drag-and-drop/src/drag-and-drop-helpers";
import React, { createRef, useEffect, useMemo, useRef, useContext, useReducer } from "react";
import { BOTTOM_PADDING_PX, GetInteractivity, useTreeBrowser, VirtualScrollingForwardRef, VirtualScrollingTreeBrowserComponent } from "@iventis/tree-browser";
import { Map } from "@iventis/domain-model/model/map";
import { useWindowSize, canEdit, sortDataFieldsOnDelete, isValidUuid, isAdmin } from "@iventis/utilities";
import { userLocalStorageItems, userLocalStorageManager } from "@iventis/local-storage/src/user-local-storage";
import { useDispatch, useSelector } from "react-redux";
import { useTheme, Button } from "@mui/material";
import { Node } from "@iventis/domain-model/model/node";
import { Theme } from "@emotion/react";
import { findNode, findNodesByType, flattenNodeTree, recursivelyAppendTopSelection } from "@iventis/tree-browser/tree-operations";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations/content/typed-content";
import { unwrapResult } from "@reduxjs/toolkit";
import { DataField } from "@iventis/domain-model/model/dataField";
import { Asset } from "@iventis/domain-model/model/asset";
import { FillSpace, sidebarHeaderMixin, styled, inlineTextIconMargin, media, verticalTransform, horizontalTransform, zIndexes } from "@iventis/styles";
import { MapEventTypes, MappingEngine, getMapOrderForNewLayer, machineEventTypes, updateExistingLayersMapOrderValue } from "@iventis/map-engine";
import GeoJSON from "geojson";
import { DragAndDropItemPlacement, DragAndDropSortable, DropZoneFill, GhostNodeComponent, SortableListType } from "@iventis/drag-and-drop";
import { TypedFeature } from "@iventis/map-engine/src/types/internal";
import { LoadingComponent, EmptyMapSidebarImage, SimpleTooltip, PermissionsToolTipComponent, DisabledOverlay } from "@iventis/components";
import { TreeBrowserDomainNodeContext } from "@iventis/tree-browser/implementations/library/helpers/library.helpers";
import { LayerEditModal } from "@iventis/layer-styles/src/edit-layer-modal";
import { mappingApi } from "@iventis/api/src/api";
import { updateUserPreferences } from "@iventis/permissions/src/auth.slice";
import { CSSTransition } from "react-transition-group";
import { feature } from "@turf/helpers";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { MapObject } from "@iventis/domain-model/model/mapObject";
import { DomainLayer } from "@iventis/map-engine/src/state/map.state.types";
import { ExportOptions } from "@iventis/map-engine/src/bridge/mapbox/engine-mapbox-types-and-constants";
import { LayerThumbnailGenerator } from "@iventis/layer-styles/src/layer-thumbnail-generator";
import { isModelLayer } from "@iventis/map-engine/src/utilities/state-helpers";
import { DataFieldModal, DataFieldConfigContext, DataFieldServicesContext, LIST_ITEMS_QUERY_KEY, LIST_ITEM_QUERY_KEY, AddPredefinedAttributeForm } from "@iventis/datafield-editor";
import { useQueryClient } from "@tanstack/react-query";
import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { toast } from "@iventis/toasts/src/toast";
import { AssetManagement } from "@iventis/domain-model/model/assetManagement";
import { AssetType } from "@iventis/domain-model/model/assetType";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { getModelLayerStyle } from "@iventis/map-engine/src/utilities/layer.helpers";
import { NodeEmptyComponent } from "@iventis/components/src/node-empty";
import { EditLayerServicesContext } from "@iventis/layer-styles";
import { getStaticAndMappedValues, hasStyleValueChanged } from "@iventis/map-engine/src/utilities/style-helpers";
import { IventisErrorBoundaryWithToast } from "@iventis/error-boundaries";
import { useHistory } from "@iventis/subscriptions";
import { v4 as uuid } from "uuid";
import {
    ExportType,
    NotificationContext,
    createLayersCopyNotification,
    createListItemExportNotification,
    createMapObjectExportNotification,
    notificationNameCreator,
} from "@iventis/notifications";
import { compareAsc } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnalysisTools } from "@iventis/analysis";
import { getMapObjectQuantityOfModelsOnLineSystemDataField, getQuantityOfModelsOnALine } from "@iventis/datafields";
import { AnySupportedGeometry, MapObjectProperties } from "@iventis/map-types";
import { MapObjectExportCadOptions } from "@iventis/domain-model/model/mapObjectExportCadOptions";
import { incrementMonitoringCount } from "@iventis/observability-and-monitoring";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { PlanChangeLogComponent } from "./change-log/plan-change-log";
import { assetService } from "./services/asset-service";
import { RootDispatch, RootState } from "./state/root.store";
import { SidebarTopNavComponent } from "./sidebar-top-nav";
import { BackgroundSelectorPreviewComponent } from "./background-selector-preview";
import { SideBarHeaderComponent } from "./sidebar-header";
import { convertLayerToBasicNode, getValidProjectDataFields, setLayerThumbnail, setViewByObject } from "./sidebar.helpers";
import { SidebarToolbarComponent } from "./sidebar-toolbar-button";
import {
    importDataFieldListItems,
    createLayerDataFieldListItem,
    deleteLayerDataFieldListItem,
    updateLayerDataFieldListItem,
    exportDataFieldListItems,
    getDataFieldListItems,
    updateLayerDataFieldListItemOrder,
    getDataFieldListItem,
} from "./services/data-field-list-item-service";
import {
    createLayerDataFieldThunk,
    createLayerRequest,
    deleteLayerDataFieldThunk,
    getRemoteLayerGeometry,
    patchMapLayers,
    updateLayerDataFieldThunk,
    updateMap,
    updateMapSidebarOrder,
} from "./state/map.slice.thunks";
import { eventStream } from "./event-stream";
import { sidebar } from "./state/sidebar.slice";
import { map as mapReducer } from "./state/map.slice";
import { SidebarDataTableComponent } from "./data-table/sidebar-data-table";
import { BACKGROUND_SELECTOR_HEIGHT_PX, BackgroundMapSelector } from "./background-selector";
import { SidebarContent, MODAL_NEW_LAYER_ID } from "./state/sidebar.slice.types";
import { editStyleService } from "./services/edit-style-service";
import { MapTourContext, MapTourStep, classNameTourBackground } from "./map-tour";
import { handleSidebarDragEnd, sortAndFilterSidebarNodes } from "./sidebar-order-helpers";
import { calculateVirtualListRemainingHeightInContainer, getStaticLibraries } from "./plan-library/mapping-library.helpers";
import { ObjectDetailsContainer } from "./object-details-container";
import { getSelectedLayers } from "./map-root";
import { SidebarDataFieldModalWrapper } from "./sidebar-datafield-modal-wrapper";
import { sidebarReducer } from "./sidebar-reducer.local";
import { ModalState, SidebarReducerActionTypes } from "./sidebar-types";
import { LAYER_THUMBNAIL_KEY, sidebarNodeComponents, sidebarNodeIcons } from "./sidebar-library/sidebar-nodes";
import { FROM_MAP_ROOT } from "./map-constants";
import { getWhat3WordsValueForObjectUpdates } from "./map-container-what3words";
import { copyLayers } from "./services/layer-service";
import { MapObjectUpdateDataField } from "./state/map.slice.types";
import { removeLayerObjectsFromStack, useMapUndoRedoContext } from "./map-undo-redo-context";
import { useMapLoading } from "./hooks/use-map-loading";
import { exportLayerAsDwg } from "./sidebar-export-helpers";

export interface SidebarTreeBrowserExtraProps {
    setSidebarPopoverAnchor: (anchor: Element) => void;
    isDragging?: boolean;
    handleDeleteNodes: (nodes: Node[]) => Promise<void>;
    setModal?: (modalState: ModalState) => void;
}

export const SideBarComponent: React.FC<{
    mapId: string;
    minWidth: number;
    windowWidth: number;
    leftWidth: number;
    className?: string;
    sidebarHidden: boolean;
    showObjectDetails: boolean;
    setSidebarHidden: (hidden: boolean) => void;
    setLeftWidth: (width: number | undefined) => void;
    setPopoverAnchor: (anchor: Element) => void;
    selectedAnalysisObjects: GeoJSON.Feature<AnySupportedGeometry, MapObjectProperties>[];
    userId: string;
    updateMapObjectNodeNames: (mapObjects: MapObject[]) => void;
    layers: { value: DomainLayer[] };
    getMapPosition: () => ExportOptions;
    setShowObjectDeletionDialog?: (showObjectDeletionDialog: boolean) => void;
}> = ({
    mapId,
    minWidth,
    windowWidth,
    leftWidth,
    setLeftWidth,
    className,
    sidebarHidden,
    setSidebarHidden,
    setPopoverAnchor,
    showObjectDetails,
    selectedAnalysisObjects,
    userId,
    updateMapObjectNodeNames,
    layers,
    getMapPosition,
    setShowObjectDeletionDialog,
}) => {
    const dispatch = useDispatch<RootDispatch>();

    const translate = useIventisTranslate();

    const sidebarRef = createRef<HTMLDivElement>();

    const theme = useTheme<Theme>();

    const history = useHistory();

    const queryClient = useQueryClient();

    const { ref: mapTourRef } = useContext(MapTourContext);

    const { createNotification } = useContext(NotificationContext);

    const virtualScrollingContainerRef = useRef<VirtualScrollingForwardRef>();
    // used to keep track of transitioning child
    const nodeRef = React.useRef(null);
    const headerNodeRef = React.useRef(null);

    const [{ tree, expandedNodeIds, pendingRequests, isLoadingTree, errorLoadingTree, selectedNodeIds }, treeBrowserContext] = useTreeBrowser(
        TreeBrowserDomainNodeContext,
        null,
        "tree",
        "expandedNodeIds",
        "pendingRequests",
        "isLoadingTree",
        "errorLoadingTree",
        "selectedNodeIds"
    );

    const { content, editingNodeName, modalLayer, previousLibraryId, attributeId, attributeLayerId, layersUndertakingPreviewSnapshots } = useSelector(
        (s: RootState) => s.sidebarReducer
    );
    const { mapName, mapModule, mappingEngine, sitemaps } = useSelector((s: RootState) => s.mapReducer);
    const { mapObjectsSelected, currentLevel } = mapModule;
    const selected = selectedNodeIds;
    const user = useSelector((s: RootState) => ({
        globalAuthorisation: s.auth.user.globalAuthorisation,
        projectAdmin: s.auth.user.projectAdmin,
        userId: s.auth.user.userId,
        projectId: s.auth.user.projectId,
        connectedToDigitalTwin: s.mapReducer.mapModule.digitalTwinEngineData.userConnectedToDigitalTwin,
    }));

    const mapNode: Node = tree ? (findNode([tree], mapId) as Node) : undefined;

    const canUserCreateLayers = canEdit(mapNode?.authorisation);

    const layerPermissions = useMemo(() => {
        if (mapNode?.childCount > 0) {
            const allNodes = flattenNodeTree(mapNode).filter((node) => node?.type === NodeType.Layer);
            return allNodes.reduce((cum, node) => ({ ...cum, [node.id]: node.authorisation }), {} as { [nodeId: string]: Authorisation });
        }
        return {} as { [nodeId: string]: Authorisation };
    }, [mapNode]);

    const userLayers = useMemo(() => mapModule.layers.value.filter((l) => l.remote), [mapModule.layers.stamp]);

    const orderedMapNode = useMemo(() => (tree != null ? { ...sortAndFilterSidebarNodes(mapNode, userLayers) } : mapNode), [tree, mapModule.layers.stamp, mapNode]);

    const undoRedo = useMapUndoRedoContext();

    const handleOnAddLayer = (skipTemplateSelection = false) => {
        dispatch(sidebar.actions.setModalLayer({ id: MODAL_NEW_LAYER_ID, anchor: "sidebar", skipTemplateSelection }));

        if (mapTourRef?.current && mapTourRef.current.isRunning() && mapTourRef.current.getStep() === MapTourStep.CREATE_LAYER) {
            mapTourRef.current.finishTour();
        }
    };

    const handleDeleteNodes = async (nodes: Node[]) => {
        // Deselect all from map
        eventStream.next({ type: machineEventTypes.selectLayer, payload: { layerId: null } });

        // Delete all nodes and children from library, apart from map objects
        const filteredNodes = nodes.filter((node) => node.type !== NodeType.MapObject);
        treeBrowserContext.deleteNodes(filteredNodes);
        const flatNodes = [];
        nodes.forEach((node) => flatNodes.push(...flattenNodeTree(node)));
        const removedLayerIds = flatNodes.filter((n) => n.type === NodeType.Layer).map((node) => node.id);
        // Delete layers from map
        dispatch(mapReducer.actions.removeLayers(removedLayerIds));
        // Remove the objects from the undo/redo stack
        undoRedo.removeFromStack((acc, entry) => removeLayerObjectsFromStack(acc, entry, removedLayerIds));
        // Refresh map tiles
        eventStream.next({ type: MapEventTypes.REFRESH_SOURCE_TILES, payload: { sourceNames: ["iventis"] } });
    };

    const parentFolder = useMemo(() => {
        const staticLibraries = getStaticLibraries();
        const staticLibrary = staticLibraries.find(({ id }) => id === previousLibraryId);
        if (staticLibrary) {
            return staticLibrary;
        }
        if (mapNode != null) {
            return findNode([tree], mapNode.parentId);
        }
        return undefined;
    }, [mapNode, tree]);

    const [sidebarReducerState, dispatchSidebarReducer] = useReducer(sidebarReducer, {
        isObjectDetailsMinimised: userLocalStorageManager.get(userLocalStorageItems.objectDetailsPanel, userId) ?? false,
        transitionCompleted: false,
        showAttributeModal: false,
        attributeDataField: null,
        modal: null,
    });

    const treeBrowserExtraProps: SidebarTreeBrowserExtraProps = {
        setSidebarPopoverAnchor: setPopoverAnchor,
        handleDeleteNodes,
        setModal: (payload) => dispatchSidebarReducer({ type: SidebarReducerActionTypes.setModal, payload }),
    };

    const findLayerForAttribute = () => {
        const attributeLayerValues = layers.value.filter((layerVal) => layerVal.id === attributeLayerId);
        if (attributeLayerValues.length === 1) {
            const filteredDataFields = attributeLayerValues[0].dataFields.filter((df) => df.id === attributeId);
            dispatchSidebarReducer({ type: SidebarReducerActionTypes.setAttributeDataField, payload: filteredDataFields[0] });
        }
    };
    useEffect(() => {
        dispatchSidebarReducer({ type: SidebarReducerActionTypes.setShowAttributeModal, payload: attributeId !== null });
        if (attributeId !== null) {
            findLayerForAttribute();
        }
    }, [attributeId]);

    const objectDetailsComponent = useMemo(() => {
        const layerNodes = findNodesByType(mapNode?.childNodes, NodeType.Layer);
        const selectedNodes = layerNodes.filter(({ id }) => selectedNodeIds.includes(id));

        return (
            <ObjectDetailsContainer
                mapObjectIdsSelected={mapObjectsSelected.value.map((ids) => ids.objectId)}
                mapLayersSelected={getSelectedLayers(selectedNodeIds, layers.value)}
                updateMapObjectNodeNames={updateMapObjectNodeNames}
                updateGeom={(mapObject) => {
                    const newFeature = mapObject.geoJsonFeature;
                    const typedFeature: TypedFeature = feature(newFeature.geometry, newFeature.properties, { id: newFeature.properties.id });
                    eventStream.next({ type: machineEventTypes.updateDrawingGeometry, payload: { features: [typedFeature], updateStore: true } });
                }}
                isObjectDetailsMinimised={sidebarReducerState.isObjectDetailsMinimised}
                setObjectDetailsMinimised={(payload) => dispatchSidebarReducer({ type: SidebarReducerActionTypes.setObjectDetailsMinimised, payload })}
                userId={userId}
                setTransitionCompleted={(payload) => dispatchSidebarReducer({ type: SidebarReducerActionTypes.setTransitionCompleted, payload })}
                transitionCompleted={sidebarReducerState.transitionCompleted}
                selectedLayerNodes={selectedNodes}
                layerPermissions={layerPermissions}
                getAsset={(assetId) => assetService.getAsset(assetId, true)}
            />
        );
    }, [mapNode?.childNodes, mapObjectsSelected, selectedNodeIds, layers.value, sidebarReducerState.isObjectDetailsMinimised]);

    useEffect(() => {
        if (sidebarRef.current) {
            if (!leftWidth) {
                setLeftWidth(sidebarRef.current?.clientWidth);
            }
        }
    }, [sidebarRef, leftWidth, setLeftWidth, windowWidth]);

    const { userPreferences } = useSelector(({ auth: { userPreferences } }: RootState) => ({
        userPreferences,
    }));

    const deselectNodes = () => {
        treeBrowserContext.toggleSelectNodes([], { from: FROM_MAP_ROOT });
        eventStream.next({ type: machineEventTypes.selectLayer, payload: { layerId: null } });
    };

    const setContent = (content: SidebarContent) => {
        dispatch(sidebar.actions.setSidebarContent(content));
    };

    const handleDragEnd = (nodes: Node[], over: { id: string }) => {
        const updatedLayers = handleSidebarDragEnd(nodes, over.id as string, mapNode, userLayers, (nodes: Node[], parentId: string) => {
            dispatch(mapReducer.actions.updateLayerGroupIds(nodes.map((layer) => ({ layerId: layer.id, groupId: parentId === mapId ? null : parentId }))));
            treeBrowserContext.moveNodes(nodes, parentId);
        });
        if (updatedLayers) {
            dispatch(mapReducer.actions.updateLayerSidebarOrder(updatedLayers));
            dispatch(updateMapSidebarOrder({ mapId: mapNode.id, layers: updatedLayers }));
        } else {
            toast.warning({
                title: translate(Content.common.warning),
                message: translate(Content.errors.three_nested),
                testId: "max-sidebar-group-depth-toast",
            });
        }
    };

    const getItems = (nodeId: string) => {
        // If node being dragged is selected also move all other selected nodes
        const draggingSelection = selected.includes(nodeId);
        return draggingSelection ? recursivelyAppendTopSelection(mapNode, selected) : [findNode(mapNode.childNodes, nodeId)];
    };

    const getInteractivity: GetInteractivity<Node> = () => {
        // Must have map edit to drag and re-order layers
        const canEditMap = mapNode != null ? isAdmin(mapNode?.authorisation) : false;
        // Disable is not implemented.
        return { disabled: false, draggable: canEditMap, selectable: { disabled: false, tooltip: undefined }, isNameClickable: canEditMap };
    };

    const dropZoneContainerRef = useRef<HTMLDivElement>(undefined);

    const { screenHeight } = useWindowSize();

    useEffect(() => virtualScrollingContainerRef?.current?.heightChanged(), [showObjectDetails, screenHeight, sidebarReducerState.transitionCompleted]);

    const updateMapObjectName = (mapObject: { id: string; name: string }) => {
        const node = findNode([tree], mapObject.id);
        if (node) {
            treeBrowserContext.updateNodeLocally({ ...node, name: mapObject.name });
        }
    };

    const handleNavigateToProjectSettings = () => {
        history.push("/project-settings/project-attributes");
    };

    const isUserProjectAdmin = useMemo(() => user.projectAdmin || user.globalAuthorisation === Authorisation.Admin, [user]);

    const handleProgressTour = () => {
        // If we have closed out of the background map are currently in the tour, show the create layer step
        if (
            mapTourRef?.current &&
            mapTourRef.current.isRunning() &&
            (mapTourRef.current.getStep() === MapTourStep.CREATE_LAYER || mapTourRef.current.getStep() === MapTourStep.BACKGROUND)
        ) {
            mapTourRef.current.maximiseTour();

            // We may have already progressed to the next step depending if we clicked through the spotlight or not
            if (mapTourRef.current.getStep() === MapTourStep.BACKGROUND) mapTourRef.current.nextStep();
        }
    };

    const putLayer = async (changedLayer: MapLayer) => {
        const oldLayer = layers.value.find((layer) => layer.id === changedLayer.id);
        // eslint-disable-next-line no-param-reassign
        changedLayer = { ...changedLayer, dataFields: changedLayer.dataFields ?? [] };
        // If the layer has switched from non-model to model, we must fetch the layers geometries
        if (!isModelLayer(oldLayer) && isModelLayer(changedLayer)) {
            await dispatch(getRemoteLayerGeometry({ layerId: changedLayer.id }));
        }

        if (oldLayer.styleType !== changedLayer.styleType) {
            dispatch(mapReducer.actions.updateMapLayer({ ...oldLayer, dataFields: changedLayer.dataFields }));
        }

        await dispatch(
            patchMapLayers([
                {
                    id: changedLayer.id,
                    name: changedLayer.name,
                    tooltipDataFieldIds: changedLayer.tooltipDataFieldIds,
                    styleType: changedLayer.styleType,
                    lineModelStyle: changedLayer.lineModelStyle,
                    pointStyle: changedLayer.pointStyle,
                    areaModelStyle: changedLayer.areaModelStyle,
                    iconStyle: changedLayer.iconStyle,
                    modelStyle: changedLayer.modelStyle,
                    lineStyle: changedLayer.lineStyle,
                    areaStyle: changedLayer.areaStyle,
                },
            ])
        );
        const node = findNode(mapNode?.childNodes, changedLayer.id);
        if (node.name !== changedLayer.name) {
            treeBrowserContext.updateNodeLocally({ ...node, name: changedLayer.name });
        }

        // Check if spacing or offset has changed on a line model
        if (
            changedLayer.styleType === StyleType.LineModel &&
            (hasStyleValueChanged(oldLayer.lineModelStyle?.spacing, changedLayer.lineModelStyle.spacing) ||
                hasStyleValueChanged(oldLayer.lineModelStyle?.modelOffset, changedLayer.lineModelStyle.modelOffset))
        ) {
            const quantityDataField = getMapObjectQuantityOfModelsOnLineSystemDataField(mapModule.projectDataFields);
            const selectedMapObject = mapModule.mapObjectsSelected.value[0];
            const layerMapObjects = mapModule.geoJSON.value?.[changedLayer.id] ?? [];
            // If spacing has changed, remove the quantity datafield value from all map objects as it is not updated
            const mapObjectDataFieldUpdates: MapObjectUpdateDataField[] = layerMapObjects.map((mapObject) => ({
                layerId: changedLayer.id,
                object: {
                    mapObjectId: mapObject.objectId,
                    dataFieldValues: {
                        [quantityDataField?.id]:
                            // If the selected map object is the same as the map object being updated, get the new quantity value else set to null
                            selectedMapObject?.objectId === mapObject?.objectId ? getQuantityOfModelsOnALine(mapObject.feature, changedLayer.lineModelStyle) : null,
                    },
                },
            }));
            if (quantityDataField?.id && mapObjectDataFieldUpdates.length > 0) {
                dispatch(mapReducer.actions.patchMapObjectDataFieldValues(mapObjectDataFieldUpdates));
            }
        }

        const what3wordsDataField = changedLayer.dataFields.some((df) => df.type === DataFieldType.What3Words);
        // If there is only one map object selected and it is the same layer which has just had what3words datafield added
        if (mapModule.mapObjectsSelected.value.length === 1 && mapModule.mapObjectsSelected.value[0].layerId === changedLayer.id && what3wordsDataField) {
            const selectedMapObject = mapModule.mapObjectsSelected.value[0];
            const mapObject = (mapModule.geoJSON.value?.[changedLayer.id] ?? []).find((object) => object.objectId === selectedMapObject.objectId);
            // Update the what3words value for the selected map object
            if (mapObject) {
                getWhat3WordsValueForObjectUpdates(
                    [
                        {
                            objectId: mapObject.objectId,
                            layerId: changedLayer.id,
                            geometry: mapObject.feature.geometry,
                            properties: mapObject.feature.properties,
                            waypoints: undefined,
                        },
                    ],
                    [changedLayer],
                    dispatch
                );
            }
        }

        dispatch(sidebar.actions.updateLayerSnapshot([changedLayer]));
    };

    const postLayer = async (layer: MapLayer) => {
        const userLayers = layers.value.filter((l) => l.remote);
        // Get new layers map order
        const layerMapOrder = getMapOrderForNewLayer(layer as DomainLayer, userLayers);
        const res = await dispatch(createLayerRequest({ ...layer, mapId, mapOrder: layerMapOrder }));
        // Update the map order of layers that need to be updated
        const updatedMapOrder = updateExistingLayersMapOrderValue(layerMapOrder, userLayers);
        await dispatch(patchMapLayers(updatedMapOrder));
        const newLayer = unwrapResult(res);
        // Add basic node to tree while we wait for NODE_CREATED web socket
        const basicNode = { ...convertLayerToBasicNode(newLayer), childCount: 0 };
        treeBrowserContext.addNodesLocally([basicNode]);
        // Scroll bottom of sidebar when a layer has been added
        virtualScrollingContainerRef.current?.scrollToBottom();
        treeBrowserContext.toggleSelectNodes([basicNode], { from: FROM_MAP_ROOT });
        treeBrowserContext.expandNode(basicNode);
        // Now we have an id assigned to the layer, we can update the modal layer with the new id
        dispatch(sidebar.actions.setModalLayer({ id: layer.id, anchor: "sidebar" }));
        dispatch(sidebar.actions.updateLayerSnapshot([layer]));
    };

    const awaitPostLayer = async (layer: MapLayer) => {
        // Need to wait for the layer to be created before we can change to draw mode
        await postLayer(layer);
        // Set to draw mode
        eventStream.next({ type: machineEventTypes.compose, payload: { objects: [{ layerId: layer.id, geojson: {}, waypoints: [] }] } });
    };

    const handleCopyOrUnlinkLayers = async (selectedLayers: MapLayer[], includeMapObjects: boolean, keepPermissions: boolean) => {
        dispatchSidebarReducer({ type: SidebarReducerActionTypes.setModal, payload: null });

        const mapLayerIds = selectedLayers.map((layer) => layer.id);
        // Get all selected groups
        const selectedGroupNodeIds = selectedNodeIds.flatMap((selectedNodeId) => {
            const foundNode = findNode(tree.childNodes, selectedNodeId);
            return foundNode?.type === NodeType.Folder ? [foundNode.id] : [];
        });

        const isUnlink = sidebarReducerState.modal === "unlink";

        if (isUnlink) {
            dispatch(mapReducer.actions.disableLayers(mapLayerIds));
        } else {
            const layersToUpdate: DomainLayer[] = [];

            // Order all the layers, ensuring the copied layers are always 1 after the layer it was a copy of
            const orderedLayers = [...layers.value]
                .filter((l) => isValidUuid(l.id))
                .sort((a, b) => (a.sidebarOrder === b.sidebarOrder ? compareAsc(a.createdAt, b.createdAt) : a.sidebarOrder - b.sidebarOrder));

            // If any layers have been changed, update them
            let previousOrder = 0;
            orderedLayers.forEach((layer) => {
                if (layer.sidebarOrder !== previousOrder + 1) {
                    layersToUpdate.push({ ...layer, sidebarOrder: previousOrder + 1 });
                }
                if (mapLayerIds.includes(layer.id)) {
                    previousOrder++;
                }
                previousOrder++;
            });

            dispatch(mapReducer.actions.updateMapLayers(layersToUpdate));
        }
        const copyId = uuid();

        createNotification(
            createLayersCopyNotification(userId, user.projectId, copyId, {
                mapId,
                name: mapLayerIds.length > 1 ? selectedLayers[0].name : `${selectedLayers[0].name}, ...`,
                deleteOriginal: isUnlink,
            })
        );

        if (isUnlink) {
            incrementMonitoringCount({ name: MetricName.UNLINK_LAYERS });
        } else if (selectedGroupNodeIds.length > 0) {
            incrementMonitoringCount({ name: MetricName.COPY_LAYERS_AND_GROUPS });
        } else {
            incrementMonitoringCount({ name: MetricName.COPY_LAYERS });
        }

        await copyLayers(mapId, {
            id: copyId,
            copyMapObjects: includeMapObjects,
            copyPermissions: keepPermissions,
            mapLayerIds,
            groupIds: isUnlink ? [] : selectedGroupNodeIds,
            deleteOriginal: isUnlink,
        });
    };

    const handleExportDwg = (selectedLayers: MapLayer[], cadOptions: MapObjectExportCadOptions) => {
        dispatchSidebarReducer({ type: SidebarReducerActionTypes.setModal, payload: null });
        selectedLayers.forEach(({ id }) => {
            incrementMonitoringCount({ name: MetricName.MAP_OBJECTS_EXPORTED_DWG, resourceId: id });
        });
        const request = exportLayerAsDwg(selectedLayers, selectedLayers[0].mapId, currentLevel, cadOptions);
        const notification = createMapObjectExportNotification(userId, user.projectId, notificationNameCreator(ExportType.LayerDwg, mapName), request);
        createNotification(notification);
    };

    const handleLayerThumbnail = async (url: string, layer: MapLayer) => {
        setLayerThumbnail(layer, url, !canEdit(mapNode.authorisation));
        queryClient.setQueryData([LAYER_THUMBNAIL_KEY, layer.id], url);
    };

    const isMapLoading = useMapLoading();

    return (
        <EditLayerServicesContext.Provider
            value={{
                assetService: {
                    ...assetService,
                    canEditAsset: (asset: Asset) => isUserProjectAdmin && asset && asset.management === AssetManagement.Internal,
                    async patchIcon(data, existingAsset) {
                        const patchedAsset = await assetService.patchIcon(data, existingAsset);
                        eventStream.next({ type: MapEventTypes.REFRESH_ASSET, payload: { assetId: existingAsset.id, type: AssetType.MapIcon } });
                        return patchedAsset;
                    },
                    async updateModel(data, existingAsset) {
                        const patchedAsset = await assetService.updateModel(data, existingAsset);

                        // Refresh both the model and model lod asset
                        eventStream.next({
                            type: MapEventTypes.REFRESH_ASSET,
                            payload: { assetId: patchedAsset.id, thumbnailAssetId: patchedAsset.thumbnailAssetId, type: AssetType.Model },
                        });

                        // Refresh the layer snapshot for every layer with that asset
                        layers.value.forEach((layer) => {
                            switch (layer.styleType) {
                                case StyleType.Model:
                                case StyleType.LineModel:
                                    if (getStaticAndMappedValues(getModelLayerStyle(layer).model).includes(patchedAsset.id)) dispatch(sidebar.actions.updateLayerSnapshot([layer]));
                                    break;
                                default:
                                    break;
                            }
                        });

                        return patchedAsset;
                    },
                    hideAssetSelectorActions: !user.projectAdmin,
                },
                styleService: { ...editStyleService, refreshAssetEvent: eventStream.listen([MapEventTypes.REFRESH_ASSET]) },

                layerService: {
                    putLayer,
                    postLayer: awaitPostLayer,
                    deleteLayer: async (layer) => {
                        const layerNode = findNode(mapNode?.childNodes, layer.id);
                        await handleDeleteNodes([layerNode]);
                    },
                },
            }}
        >
            <DataFieldServicesContext.Provider
                value={{
                    dataFieldsService: {
                        postDataField: async (dataField, layerId) => {
                            await dispatch(createLayerDataFieldThunk({ layerId, dataField }));
                        },
                        putDataField: async (dataField, layerId) => {
                            const previousDataField = layers.value.find((l) => l.id === layerId)?.dataFields?.find((df) => df.id === dataField.id);
                            await dispatch(updateLayerDataFieldThunk({ layerId, dataField, previousDataField }));
                        },
                        deleteDataField: async (dataFieldId, layerId) => {
                            const layer = layers.value.find((l) => l.id === layerId);
                            const dataField = layer.dataFields.find((df) => df.id === dataFieldId);
                            await dispatch(deleteLayerDataFieldThunk({ layerId, dataFieldId }));
                            // Update all the other data fields with their new order
                            const orderedDataFields = sortDataFieldsOnDelete(layer.dataFields, dataFieldId);
                            const dataFieldsToUpdate = orderedDataFields.filter((dataField) => dataField.order !== layer.dataFields.find((df) => df.id === dataField.id)?.order);
                            for (let i = 0; i < dataFieldsToUpdate.length; i += 1) {
                                const previousDataField = layer.dataFields.find((df) => df.id === dataFieldsToUpdate[i].id);
                                await dispatch(updateLayerDataFieldThunk({ layerId, dataField: dataFieldsToUpdate[i], previousDataField }));
                            }

                            eventStream.next({ type: "DATAFIELD_DELETED", payload: { layerId, dataField } });
                            // Get deleted datafield from layer
                            if (layer.viewById === dataFieldId) {
                                setViewByObject(layer.id, treeBrowserContext, tree);
                            }
                        },
                        getDataFieldsForResource: async (resourceId) => mappingApi.get<DataField[]>(`/layers/${resourceId}/data-fields`).then((reponse) => reponse.data),
                        isDataFieldBeingUsed: () => Promise.resolve(true),
                    },
                    dataFieldListItemsService: {
                        postDataFieldListItem: async (dataFieldListItem, dataFieldId, layerId) => {
                            await createLayerDataFieldListItem({ dataFieldListItem, dataFieldId, layerId });
                            await queryClient.invalidateQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                            eventStream.next({ type: machineEventTypes.refreshAttributeListItems, payload: { attributeId: dataFieldId, layerId } });
                        },
                        putDataFieldListItem: async (dataFieldListItem, dataFieldId, layerId) => {
                            await updateLayerDataFieldListItem({ dataFieldListItem, dataFieldId, layerId });
                            queryClient.setQueryData([LIST_ITEM_QUERY_KEY, dataFieldListItem.id], dataFieldListItem);
                            await queryClient.invalidateQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                            queryClient.removeQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                            eventStream.next({ type: machineEventTypes.refreshAttributeListItems, payload: { attributeId: dataFieldId, layerId } });
                        },
                        patchDataFieldListItemOrder: async (dataFieldId, listItem) => {
                            await updateLayerDataFieldListItemOrder(dataFieldId, listItem);
                            await queryClient.invalidateQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                        },
                        deleteDataFieldListItem: async (dataFieldListItemId, dataFieldId, layerId) => {
                            await deleteLayerDataFieldListItem({ dataFieldListItemId, dataFieldId, layerId });
                            await queryClient.invalidateQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                            eventStream.next({ type: machineEventTypes.refreshAttributeListItems, payload: { attributeId: dataFieldId, layerId } });
                        },
                        getDataFieldListItems: getDataFieldListItems(queryClient),
                        getDataFieldListItem,
                        importDataFieldListItems: async (dataFieldId, csv, layerId, deleteExisting) => {
                            await importDataFieldListItems({ dataFieldId, csv, deleteExisting });
                            await queryClient.invalidateQueries([LIST_ITEMS_QUERY_KEY, dataFieldId]);
                            eventStream.next({ type: machineEventTypes.refreshAttributeListItems, payload: { attributeId: dataFieldId, layerId } });
                        },
                        exportDataFieldListItems: async (dataFieldId) => {
                            const notificationId = uuid();
                            const dataField = layers.value.flatMap((layer) => layer.dataFields).find((df) => df.id === dataFieldId);
                            await exportDataFieldListItems({ dataFieldId }, notificationId);
                            const notificationName = notificationNameCreator(ExportType.LayerAttribute, dataField.name);
                            const notification = createListItemExportNotification(user.userId, user.projectId, notificationId, notificationName);
                            createNotification(notification);
                        },
                    },
                }}
            >
                <LayerEditModal
                    // If the modalLayerId includes the CREATED prefix, it means the layer modal is open with a newly created layer
                    open={modalLayer?.anchor === "sidebar"}
                    mapName={mapNode?.name}
                    close={() => {
                        dispatch(sidebar.actions.setModalLayer(null));
                    }}
                    showTour={userPreferences.showLayerTour}
                    finishTour={() => dispatch(updateUserPreferences({ showLayerTour: false }))}
                    navigateToProjectSettings={isUserProjectAdmin ? handleNavigateToProjectSettings : null}
                    canUserEdit
                    skipTemplateSelection={modalLayer?.skipTemplateSelection}
                    showMapObjectDataFieldSelectionForTooltip
                />
                <DataFieldConfigContext.Provider value={{ resourceId: attributeLayerId, allowSetDefaultValue: true, validateListItem: () => true }}>
                    <SidebarDataFieldModalWrapper>
                        {sidebarReducerState.showAttributeModal && (
                            <DataFieldModal
                                open={sidebarReducerState.showAttributeModal}
                                onClose={() => dispatch(sidebar.actions.setAttributeEditingId({ attributeId: null, attributeLayerId: null }))}
                                close={() => dispatch(sidebar.actions.setAttributeEditingId({ attributeId: null, attributeLayerId: null }))}
                                existingDataField={sidebarReducerState.attributeDataField}
                                createableProjectDataFields={[]}
                                allowDeletion={canEdit(layerPermissions[attributeLayerId])}
                            />
                        )}
                        {sidebarReducerState.modal === "addAttributes" && (
                            <AddPredefinedAttributeForm
                                onClose={() => dispatchSidebarReducer({ type: SidebarReducerActionTypes.setModal, payload: null })}
                                attributes={getValidProjectDataFields(mapModule.projectDataFields, getSelectedLayers(selectedNodeIds, layers.value))}
                                saveAttribute={async (dataField: DataField) => {
                                    const selectedLayers = getSelectedLayers(selectedNodeIds, layers.value);
                                    const createDataFieldRequests = selectedLayers.map((layer) => dispatch(createLayerDataFieldThunk({ layerId: layer.id, dataField })));
                                    await Promise.all(createDataFieldRequests);
                                }}
                                saveDefaultValue={async (dataField: DataField) => {
                                    const selectedLayers = getSelectedLayers(selectedNodeIds, layers.value);
                                    const updateDataFieldRequests = selectedLayers.map((layer) =>
                                        dispatch(
                                            updateLayerDataFieldThunk({
                                                layerId: layer.id,
                                                dataField,
                                                previousDataField: layer.dataFields.find((df) => df.id === dataField.id),
                                            })
                                        )
                                    );
                                    await Promise.all(updateDataFieldRequests);
                                }}
                            />
                        )}
                    </SidebarDataFieldModalWrapper>
                </DataFieldConfigContext.Provider>
                {layersUndertakingPreviewSnapshots.map((layer) => (
                    <LayerThumbnailGenerator
                        key={layer.id}
                        layer={layer}
                        services={{ ...editStyleService, setLayerThumbnail: (url) => handleLayerThumbnail(url, layer) }}
                        onDone={() => dispatch(sidebar.actions.snapshotComplete(layer.id))}
                    />
                ))}
                <StyledSideBar className={className} minWidth={minWidth} hidden={sidebarHidden} ref={sidebarRef} showLoading={isLoadingTree}>
                    <>
                        <HeaderErrorBoundary size="overlay" toast={toast}>
                            <CSSTransition nodeRef={headerNodeRef} in={!sidebarHidden} timeout={350} className="minimise-sidebar-transition__header" appear>
                                <div ref={headerNodeRef}>
                                    <SideBarHeaderComponent
                                        parentFolder={parentFolder}
                                        treeId={tree?.id}
                                        sidebarHidden={sidebarHidden}
                                        setSidebarHidden={setSidebarHidden}
                                        setSidebarPopoverAnchor={setPopoverAnchor}
                                        mapName={mapName}
                                    />
                                </div>
                            </CSSTransition>
                        </HeaderErrorBoundary>
                        <CSSTransition nodeRef={nodeRef} in={!sidebarHidden} timeout={300} className="minimise-sidebar-transition" unmountOnExit appear>
                            <div ref={nodeRef}>
                                <section className={`sidebar-content ${content}`}>
                                    {content !== SidebarContent.CHANGE_LOG && (
                                        <SidebarTopNavComponent content={content} setContent={setContent} mapNode={mapNode} handleOnAddLayer={handleOnAddLayer} />
                                    )}
                                    {content === SidebarContent.BACKGROUND_MAP && (
                                        <IventisErrorBoundaryWithToast toast={toast}>
                                            <BackgroundMapSelector
                                                onSave={(backgroundSelecterPayload) => {
                                                    const map: Partial<Map> = {
                                                        id: mapNode.id,
                                                        backgroundId: backgroundSelecterPayload.backgroundMap.id,
                                                        terrainEnabled: backgroundSelecterPayload.terrainEnabled,
                                                        globeEnabled: backgroundSelecterPayload.globeEnabled,
                                                        buildings3DEnabled: backgroundSelecterPayload.buildings3dEnabled,
                                                        streetNamesEnabled: backgroundSelecterPayload.streetNamesEnabled,
                                                    };
                                                    dispatch(updateMap({ map }));
                                                    handleProgressTour();
                                                    setContent(SidebarContent.LAYERS);
                                                }}
                                                onClose={() => {
                                                    handleProgressTour();
                                                    setContent(SidebarContent.LAYERS);
                                                }}
                                                onMapSelected={(backgroundId: string) => {
                                                    dispatch(mapReducer.actions.setMapBackground(backgroundId));
                                                }}
                                                canSave={isAdmin(mapNode?.authorisation)}
                                            />
                                        </IventisErrorBoundaryWithToast>
                                    )}
                                    {content === SidebarContent.DATA_TABLE && (
                                        <IventisErrorBoundaryWithToast toast={toast} action="reload" testId="error-boundary-data-table">
                                            <SidebarDataTableComponent
                                                sidebarWidth={leftWidth}
                                                layerPermissions={layerPermissions}
                                                projectDataFields={mapModule.projectDataFields}
                                                siteMaps={sitemaps}
                                                updateMapObjectName={updateMapObjectName}
                                                setShowObjectDeletionDialog={setShowObjectDeletionDialog}
                                            />
                                        </IventisErrorBoundaryWithToast>
                                    )}
                                    {content === SidebarContent.CHANGE_LOG && (
                                        <IventisErrorBoundaryWithToast toast={toast}>
                                            <PlanChangeLogComponent planId={mapId} onClose={() => setContent(SidebarContent.LAYERS)} />
                                        </IventisErrorBoundaryWithToast>
                                    )}
                                    {content === SidebarContent.LAYERS && (
                                        <IventisErrorBoundaryWithToast toast={toast}>
                                            {isLoadingTree || isMapLoading ? (
                                                <LoadingComponent />
                                            ) : errorLoadingTree ? (
                                                <FillSpace />
                                            ) : mapNode.childNodes.length === 0 ? (
                                                <NodeEmptyComponent
                                                    node={mapNode}
                                                    image={<EmptyMapSidebarImage />}
                                                    callToAction={
                                                        <SimpleTooltip text={<PermissionsToolTipComponent />} placement="right" disabled={canUserCreateLayers}>
                                                            <div className="create-layer-sidebar-button-wrapper">
                                                                {!canUserCreateLayers && <DisabledOverlay />}
                                                                <Button onClick={() => handleOnAddLayer(false)} variant="contained" data-testid="create-new-layer-button">
                                                                    <StyledIconContainer>
                                                                        <FontAwesomeIcon icon={{ prefix: "far", iconName: "plus" }} />
                                                                    </StyledIconContainer>
                                                                    {translate(Content.common.buttons.createLayer)}
                                                                </Button>
                                                            </div>
                                                        </SimpleTooltip>
                                                    }
                                                />
                                            ) : (
                                                <StyledBrowserWrapper onClick={() => !editingNodeName && deselectNodes()} ref={dropZoneContainerRef}>
                                                    <IventisErrorBoundaryWithToast toast={toast}>
                                                        <DragAndDropSortable<Node>
                                                            items={mapNode.childNodes}
                                                            listType={SortableListType.VIRTUAL_SCROLLING}
                                                            getItems={getItems}
                                                            calculateNewParent={(id: string) => findNode([mapNode], id)}
                                                            findBottomItem={(node: Node) => node.id}
                                                            onDragStart={() => {}}
                                                            onDragEnd={handleDragEnd}
                                                            collisionDetection={pointerAboveBelow}
                                                            idSuffixes={["bottom"]}
                                                            createOverlayComponent={(nodes) => {
                                                                const getIcon = () => {
                                                                    const { id, name } = nodes[0];
                                                                    return nodes.length > 1
                                                                        ? sidebarNodeIcons(theme)[NodeType.Layer]
                                                                        : queryClient.getQueryData([LAYER_THUMBNAIL_KEY, id]) && (
                                                                              <img
                                                                                  style={{ objectFit: "cover", width: "15px", height: "15px" }}
                                                                                  src={queryClient.getQueryData([LAYER_THUMBNAIL_KEY, id])}
                                                                                  alt={name}
                                                                              />
                                                                          );
                                                                };
                                                                return (
                                                                    <GhostNodeComponent
                                                                        getIconFunc={getIcon}
                                                                        count={nodes.length}
                                                                        name={
                                                                            nodes.length > 1
                                                                                ? translate(Content.library.drag_and_drop.moving_multiple_items, { count: nodes.length })
                                                                                : nodes[0].name
                                                                        }
                                                                    />
                                                                );
                                                            }}
                                                        >
                                                            <VirtualScrollingTreeBrowserComponent<Node, SidebarTreeBrowserExtraProps>
                                                                node={orderedMapNode}
                                                                openNodes={expandedNodeIds}
                                                                components={sidebarNodeComponents}
                                                                extraProps={treeBrowserExtraProps}
                                                                getInteractivity={getInteractivity}
                                                                containerRef={dropZoneContainerRef}
                                                                ref={virtualScrollingContainerRef}
                                                                headerNodeIds={expandedNodeIds}
                                                                createFooterComponent={(height, node) => {
                                                                    if (node) {
                                                                        return (
                                                                            <StyledDropZone
                                                                                className="drop-zone-fill"
                                                                                dataTestId="sidebar-empty-drop-zone"
                                                                                id={node.type === NodeType.Folder ? `${node.id}bottom` : mapNode.id}
                                                                                containerElementRef={dropZoneContainerRef}
                                                                                height={height < BOTTOM_PADDING_PX ? BOTTOM_PADDING_PX : height - BACKGROUND_SELECTOR_HEIGHT_PX}
                                                                            >
                                                                                <DragAndDropItemPlacement insideGroup={node.type === NodeType.Folder} />
                                                                            </StyledDropZone>
                                                                        );
                                                                    }
                                                                    return null;
                                                                }}
                                                                calculateRemainingVirtualHeight={calculateVirtualListRemainingHeightInContainer}
                                                            />
                                                        </DragAndDropSortable>
                                                    </IventisErrorBoundaryWithToast>
                                                    {pendingRequests.map((item) => (
                                                        <StyledLoadingNodeWrapper key={typeof item === "string" ? item : item.requestId}>
                                                            <LoadingComponent />
                                                        </StyledLoadingNodeWrapper>
                                                    ))}
                                                </StyledBrowserWrapper>
                                            )}
                                            {mappingEngine === MappingEngine.Mapbox && showObjectDetails && objectDetailsComponent}
                                            {selectedAnalysisObjects.length > 0 && (
                                                <AnalysisTools
                                                    selectedObjects={selectedAnalysisObjects}
                                                    unitOfMeasurement={mapModule.unitOfMeasurement.value}
                                                    mapId={mapId}
                                                    layers={userLayers}
                                                    userId={userId}
                                                />
                                            )}
                                            <IventisErrorBoundaryWithToast toast={toast}>
                                                <BackgroundSelectorPreviewComponent
                                                    className={`background-selector-button ${classNameTourBackground}`}
                                                    onClick={() => {
                                                        setContent(SidebarContent.BACKGROUND_MAP);
                                                        if (mapTourRef?.current && mapTourRef.current.isRunning() && mapTourRef.current.getStep() === MapTourStep.BACKGROUND) {
                                                            mapTourRef.current.minimiseTour();
                                                        }
                                                    }}
                                                    onSave={
                                                        isAdmin(mapNode?.authorisation)
                                                            ? (backgroundId) => {
                                                                  dispatch(updateMap({ map: { id: mapNode.id, backgroundId } }));
                                                              }
                                                            : undefined
                                                    }
                                                />
                                                <SidebarToolbarComponent
                                                    map={mapNode}
                                                    mapId={mapId}
                                                    handleDeleteNodes={handleDeleteNodes}
                                                    getMapPosition={getMapPosition}
                                                    handleExportDwg={handleExportDwg}
                                                    handleCopyOrUnlinkLayers={handleCopyOrUnlinkLayers}
                                                    modal={sidebarReducerState.modal}
                                                    setModal={(payload) => dispatchSidebarReducer({ type: SidebarReducerActionTypes.setModal, payload })}
                                                />
                                            </IventisErrorBoundaryWithToast>
                                        </IventisErrorBoundaryWithToast>
                                    )}
                                </section>
                            </div>
                        </CSSTransition>
                    </>
                </StyledSideBar>
            </DataFieldServicesContext.Provider>
        </EditLayerServicesContext.Provider>
    );
};

const HeaderErrorBoundary = styled(IventisErrorBoundaryWithToast)`
    ${sidebarHeaderMixin}
`;

const StyledSideBar = styled.aside<{ hidden: boolean; minWidth: number; showLoading: boolean }>`
    width: 100%;
    position: absolute;
    z-index: ${zIndexes.mapSidebar.root};
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    // If hidden, set to height of header
    min-height: ${({ hidden }) => (hidden ? "3.5rem" : "100%")};
    align-items: stretch;
    box-shadow: ${({ hidden }) => (hidden ? "none" : "4px 0 6px 0 rgba(117, 117, 117, 0.6)")};

    header {
        box-shadow: ${({ hidden }) => (hidden ? "4px 0 6px 0 rgba(117, 117, 117, 0.6)" : "none")};
    }

    .minimise-sidebar-transition {
        /* we want to disable animation for initial load */
        transition: ${({ showLoading }) => (showLoading ? "none" : "all 0.2s ease-in-out")};
        transform: ${verticalTransform};
        ${media.medium} {
            transform: ${horizontalTransform};
        }

        &.enter {
            transform: ${verticalTransform};
            ${media.medium} {
                transform: ${horizontalTransform};
            }
        }

        &.exit,
        &.enter-active,
        &.enter-done {
            transform: translate3d(0, 0, 0);
        }

        &.exit-active {
            transform: ${verticalTransform};
            ${media.medium} {
                transform: ${horizontalTransform};
            }
        }
    }

    ${media.medium} {
        /* we want to disable animation for initial load */
        transition: ${({ showLoading }) => (showLoading ? "none" : "all 0.2s ease-in-out")};
        .minimise-sidebar-transition__header {
            transform: translate3d(calc(-100% + 44px), 0, 0);

            &.enter {
                transform: translate3d(calc(-100% + 44px), 0, 0);
            }

            &.exit,
            &.enter-active,
            &.enter-done {
                transform: translate3d(0, 0, 0);
            }

            &.exit-active {
                transform: translate3d(calc(-100% + 44px), 0, 0);
            }
        }
    }

    .sidebar-content {
        background-color: ${({ theme }) => theme.shades.five};
        // TODO: NO FIXED VALUES (FIGURE OUT WAY TO FIT THE REST OF COMPONENT)
        height: calc(100dvh - 101px);
        display: flex;
        align-items: stretch;
        flex-direction: column;
        position: relative;
        transition: all 0.3s ease-in-out;
    }

    .layers-view {
        display: grid;
        grid-template-rows: ${({ theme }: { theme: Theme }) => `auto auto ${theme.sizes.iconButtonWidth} ${theme.sizes.iconButtonWidth}`};
    }

    .background-selector-button {
        border-top: ${({ theme }) => `1px solid ${theme.shades.four}`};
    }

    .analysis-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        /* flex-grow: 1;
        overflow-y: scroll; */
    }

    .create-layer-sidebar-button-wrapper {
        position: relative;
    }
`;

const StyledBrowserWrapper = styled.div`
    width: 100%;
    overflow-y: auto;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex: 1 1;
`;

const StyledLoadingNodeWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 44px;
`;

const StyledDropZone = styled(DropZoneFill)<{ height: number }>`
    height: ${({ height }) => height}px;
    position: relative;
`;

const StyledIconContainer = styled.span`
    margin-right: ${inlineTextIconMargin};
    color: ${({ theme }: { theme: Theme }) => theme.typographyColors.blank};
`;
